// removed by extract-text-webpack-plugin
module.exports = {"main":"_2Aer-3j-Bx5bZbzu3BOrTR"};


//////////////////
// WEBPACK FOOTER
// ./components/LoginFooter.module.css
// module id = 2362
// module chunks = 1